var _desc, _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    rx: -0.5,
    width: 31,
    height: 31,
    transform: "translate(0.500000 0.500000)",
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16C20 18.2 18.2 20 16 20C13.79 20 12 18.2 12 16C12 13.79 13.79 12 16 12C18.2 12 20 13.79 20 16Z",
    fill: "#46A053",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20C13.79 20 12 18.2 12 16C12 13.79 13.79 12 16 12C18.2 12 20 13.79 20 16C20 18.2 18.2 20 16 20Z",
    stroke: "#46A053",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63 22.36C8.81 21.54 8.16 20.57 7.71 19.5C7.24 18.39 6.99 17.2 6.99 16C6.99 14.79 7.24 13.6 7.71 12.5C8.16 11.43 8.81 10.45 9.63 9.63",
    stroke: "#46A053",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.36 9.63C23.18 10.45 23.83 11.43 24.28 12.5C24.75 13.6 25 14.79 25 16C25 17.2 24.75 18.39 24.28 19.5C23.83 20.57 23.18 21.54 22.36 22.36",
    stroke: "#46A053",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1 25.89C4.82 24.62 3.8 23.11 3.1 21.44C2.37 19.72 1.99 17.87 1.99 16C1.99 14.12 2.37 12.27 3.1 10.54C3.8 8.88 4.82 7.37 6.1 6.09",
    stroke: "#46A053",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9 6.09C27.17 7.37 28.19 8.88 28.9 10.54C29.62 12.27 30 14.12 30 16C30 17.87 29.62 19.72 28.9 21.44C28.19 23.11 27.17 24.62 25.9 25.89",
    stroke: "#46A053",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.4b67a5b9a49c9d90cb43afc1ac564d7f.svg";
export { ForwardRef as ReactComponent };